import { combineReducers } from 'redux';

import walletReducer from './customer/walletReducer';
import notificationReducer from './notificationReducer';

import authReducer from './authReducer';
import servicesReducer from './customer/servicesReducer';
import transactionsReducer from './customer/transactionsReducer';
import beneficiariesReducer from './customer/beneficiariesReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  customer: combineReducers({
    wallet: walletReducer,
    services: servicesReducer,
    transactions: transactionsReducer,
    beneficiaries: beneficiariesReducer,
  }),
  notification: notificationReducer
});

export default rootReducer;